import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/ui-config')({
  beforeLoad: () => getTitleContextSlice('UI Config'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
